export default __webpack_public_path__ + "img/70ce615cafc98489d33e74a796cd0500.png";